module.exports = __webpack_public_path__ + "img/arrow-right.fcaf3c80.svg";